import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckLarge = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 29.5,
			stroke: "#005AA0",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.2843 22L48.8198 25.5355L29.0208 45.3345L17 33.3137L20.5355 29.7782L29.0208 38.2635L45.2843 22Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgCheckLarge);
export { ForwardRef as ReactComponent };
